// extracted by mini-css-extract-plugin
export default {"wrapper":"DifferentTogether_wrapper__wCnUp","articleWrapper":"DifferentTogether_articleWrapper__nd5-G"};